module.exports = __webpack_public_path__ + "static/media/INZ1024.27852bba.pdf";